import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("No")

import Modal from '@/components/Modal/Modal.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const visible = ref(false);
const header = ref('');
const content = ref('');

const resolveFnc = ref();
const rejectFnc = ref();

function handleClick(value: boolean) {
  resolveFnc.value(value);
  visible.value = false;
}

function show(title: string, body: string) {
  header.value = title;
  content.value = body;

  visible.value = true;

  return new Promise((resolve, reject) => {
    resolveFnc.value = resolve;
    rejectFnc.value = reject;
  });
}

expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (visible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: header.value,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (handleClick(false)))
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick(true)))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick(false)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(content.value) + " ", 1)
          ]),
          _: 1
        }, 8, ["header"]))
      : _createCommentVNode("", true)
  ]))
}
}

})